/**
 * Created by pratik budhathoki on 2/28/2018.
 */
(function() {
    'use strict';

    angular
        .module('eAccess.ProviderPortal.Components.PatientDataConflict')
        .config(router);

    router.$inject = ['$stateProvider', 'GLOBAL_CONSTS'];

    function router($stateProvider, GLOBAL_CONSTS) {
        $stateProvider
            .state('rxDataConflict', {
                url: '/eligibility/rx/dataConflict/{responseId}',
                data: {
                    authorities: [],
                    pageTitle: GLOBAL_CONSTS.PORTAL_PAGE_TITLE + ' - RxEligibility'
                },
                views: {
                    'content@': {
                        templateUrl: 'components/eligibility/bv-selection/rx/patient-information-conflict/patient-information-conflict.html',
                        controller: 'PatientDataConflictController as dataConflictCtrl'
                    }
                },
                params: {
                    'responseId': ''
                }
            });
    }
})();
